import { ERROR_CODES } from '@boltenergy-be/shared'

// Errors that are logged as a warning instead of an error in Sentry.
// These are handled with a custom error message.
export const HANDLED_ERROR_CODES = [
  ERROR_CODES.eanAlreadyInPortfolio,
  ERROR_CODES.requestedProducerFull,
  ERROR_CODES.badGraydonCreditCheck
] as const
